export default "__VITE_ASSET__YZdRUSeN__"